<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { tenant, cve, callback } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    cve: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function toggleAction() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.dev.postToggleWebsiteCve', {
                tenant: tenant.id,
            }),
            {
                cveId: cve.id,
            },
        )
        .then(() => {
            loading.value = false;

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleAction" :loading="loading" />
</template>
